// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1313) return "static/chunks/1313.e6441f6bcff819d3.js";
	if (chunkId === 4173) return "static/chunks/4173.37f99c7f078e053b.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1804":"shared","2736":"headlessui","5730":"44530001"}[chunkId] || chunkId) + "-" + {"1712":"ab339db7cdf3806f","1804":"da4be80ae414cb87","2736":"8a79b7c16199f67d","3501":"0c793a4caa39f64b","5730":"77d3c16e9b1453d0","7817":"4ac45649dde83052"}[chunkId] + ".js";
};